import React from "react";
import Page from "../components/Page";

// Import
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuthFunctions } from "../hooks/useAuthFunctions";

// Import for Display
import LoadingPage from "./LoadingPage";

function LoginPage() {
  // Accesing Data
  const singleTypeSlug = "sign-in";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;
  const { handleLogin } = useAuthFunctions();

  // Only load if data has returned.
  if (!cmsData) return <LoadingPage />;

  return (
    <Page data-wf-page="63509653b197fc0b35b254a3" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container authcontainer w-container">
          <div className="iconbox">
            <img src={cmsData.image.data && cmsData.image.data.attributes.url} loading="lazy" alt="" />
          </div>
          <h1 className="textroyalblue">{cmsData.title}</h1>

          {/* Render form. */}
          <div className="authformblock w-form">
            <form id="email-form" onSubmit={handleLogin} className="authform">
              <input type="email" className="formtextfield fillgainsboro w-input" maxLength={256} name="email" placeholder="Email *" id="signin-email" required={true} />
              <input type="password" className="formtextfield fillgainsboro w-input" maxLength={256} name="password" placeholder="Password *" id="signin-password" required={true} />
              <Link to="/sign-up" className="linksignup w-inline-block">
                <div>{cmsData.signUpText}</div>
              </Link>
              <input type="submit" defaultValue="Sign In" data-wait="Please wait..." className="buttonsubmit w-button" />
            </form>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default LoginPage;
